import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import en from './locales/en.json'
import ar from './locales/ar.json'
import gr from './locales/gr.json'

function syncDomLangDir() {
  if (typeof document === "undefined") return;
  const lng = i18n.resolvedLanguage ?? i18n.language ?? "en";
  const base = String(lng).split(/[-_]/)[0].toLowerCase();
  const direction =
    base === "ar" || base === "he" || base === "fa"
      ? "rtl"
      : typeof i18n.dir === "function"
        ? i18n.dir(lng)
        : "ltr";

  document.documentElement.setAttribute("dir", direction);
  document.documentElement.setAttribute("lang", lng);

  const root = document.getElementById("root");
  if (root) root.setAttribute("dir", direction);
}

i18n.on("initialized", syncDomLangDir);
i18n.on("languageChanged", syncDomLangDir);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['en', 'ar', 'gr'],
    resources: {
      en: { translation: en },
      ar: { translation: ar },
      gr: { translation: gr },
    },
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    // German strings live under locale key ``gr`` (legacy); browsers report ``de``.
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'lang',
      caches: ['localStorage'],
      convertDetectedLanguage: (lng) => {
        if (!lng || typeof lng !== 'string') return lng;
        const base = lng.split(/[-_]/)[0].toLowerCase();
        if (base === 'de') return 'gr';
        return base;
      },
    },
  })
  .then(syncDomLangDir)

export default i18n
